import types from "./actionTypes";
import LoaderActions from "./loaderActions";
import { fetchEnvironment } from "./../../services/environment";

class EnvironmentActions {
    static get(forceNoCache) {
        return async function (dispatch) {
            dispatch(LoaderActions.startAsyncCall());
            try {
                const info = await fetchEnvironment(forceNoCache);
                dispatch(EnvironmentActions._set(info));
            } catch (error) {
                dispatch(LoaderActions.errorAsyncCall());
            }
        };
    }

    static _set(info) {
        return {
            type: types.ENVIRONMENT.SET,
            info
        };
    }
}
export default EnvironmentActions;
